module.exports = __webpack_public_path__ + "img/bg2.a1c1aea8.jpg";